import { createContext } from "react";

const paramPays ={
    pays : "BJ",
    adminpaysExiste: false
    
  }
  
  
const AdminpaysContxt = createContext(paramPays.adminpaysExiste);
export default AdminpaysContxt;
